import DatasetAttributeModel from './dataset_attribute';
import {ATTRIBUTES} from "../../../../utils/query_utils";

export default class ColumnModel extends DatasetAttributeModel {
    type = ATTRIBUTES.COLUMN;

    get sql() {
        return this.column.sqlName;
    }
}
